import { render, staticRenderFns } from "./ArchivePhds.vue?vue&type=template&id=1a4a6a98&scoped=true&"
import script from "./ArchivePhds.vue?vue&type=script&lang=js&"
export * from "./ArchivePhds.vue?vue&type=script&lang=js&"
import style0 from "./ArchivePhds.vue?vue&type=style&index=0&id=1a4a6a98&prod&lang=css&"
import style1 from "./ArchivePhds.vue?vue&type=style&index=1&id=1a4a6a98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4a6a98",
  null
  
)

export default component.exports